export default __webpack_public_path__ + "ec82f282c7f54b6370985bdf8406d5b7.ttf";